export default __webpack_public_path__ + "static/media/038-compass.5de78533.png";